import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';

import { useCustomTheme } from '../../styles';
import {
	SpinnerRoot
} from './styled';


type SpinnerProps = {
	appearance?: 'simple' | 'embedded';
	color?: 'primary' | 'white';
} & Pick<CircularProgressProps, 'size' | 'thickness'>

const thicknessMap = {
	'simple': 4,
	'embedded': 4,
};

const sizeMap = {
	'simple': 38,
	'embedded': 16,
};

const useStyles = makeStyles<any, SpinnerProps, any>(materialTheme => {
	const [theme] = useCustomTheme(materialTheme);

	return {
		progress: ({ color }) => ({
			color: color === 'primary' ? theme.color.accentPrimary : '#fff',
		}),
	}
});

const Spinner: React.SFC<SpinnerProps> = (props) => {
	const {
		appearance,
		color,
		...rest
	} = props;
	const thickness = thicknessMap[appearance as string];
	const size = sizeMap[appearance as string];
	const classes = useStyles(props);

  return (
		<SpinnerRoot color={color}>
			<CircularProgress
				className={classes.progress}
				thickness={thickness}
				size={size}
				{...rest} />
		</SpinnerRoot>
  );
}

Spinner.displayName = 'Spinner';
Spinner.defaultProps = {
	appearance: 'simple',
	color: 'primary'
};

export default Spinner;
